import { render, staticRenderFns } from "./nmsLicense.vue?vue&type=template&id=6fd57cc0&scoped=true&"
import script from "./nmsLicense.vue?vue&type=script&lang=js&"
export * from "./nmsLicense.vue?vue&type=script&lang=js&"
import style0 from "./nmsLicense.vue?vue&type=style&index=0&id=6fd57cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd57cc0",
  null
  
)

export default component.exports